module.exports = __webpack_public_path__ + "img/grofers.61c369e7.png";